module.exports = __webpack_public_path__ + "static/media/mozza-2022-mb_fr.0259b659.jpg";